<script setup lang="ts">
withDefaults(
    defineProps<{
        rows?: number
        columns?: number
    }>(),
    { rows: 5, columns: 4 }
)
</script>

<template>
    <table class="w-full">
        <tbody>
            <tr v-for="r in rows" :key="r" class="border-b border-gray-200">
                <td v-for="c in columns" :key="c" class="px-3 py-3">
                    <div class="h-3 rounded-4 skel-anim bg-gray-200" :style="{ width: `${40 + ((c * 13) % 50)}%` }" />
                </td>
            </tr>
        </tbody>
    </table>
</template>

<style scoped>
@keyframes skel-shimmer {
    0% {
        opacity: 0.6;
    }
    50% {
        opacity: 1;
    }
    100% {
        opacity: 0.6;
    }
}
.skel-anim {
    animation: skel-shimmer 1.4s ease-in-out infinite;
}
</style>
